var $ = jQuery = require('jquery')
require('./helpers');
require('./finger');

$(document).ready(function () {

  var oldandroidmatch = navigator.userAgent.match(/Android.*4\.(\d)/);
  if (oldandroidmatch && parseInt(oldandroidmatch[1])<4) {
    $('body').addClass('oldandroid');
  }

  /*-------------------------------------mobile scripts--------------------------------------*/
  if (isMobile()) {
    $('body').addClass('mobile');

    /*------------------------------ start sider ---------------------------------*/

    if ($('.countries_wrap a').length > 2) $('.countries_wrap').mySlidePlugin(2, 10);
    if ($('.carlist li').length > 1) $('.carlist').mySlidePlugin(1,0);
    $('.innerservices').wrapInner('<div />').children().mySlidePlugin(1,1)

    /*-----------------------------------------------------------------------------*/

    $('.mobile_check_button').click(function () {
      scroll_to_search_form();
    })



    /*------------------------------------------------------------------------------*/

    $('.moblie_sticky button').click(function () {
      ga('send','event', 'user action', 'click', 'mobile top sticky');
      $('body').addClass('refine-search');
      scroll_to_search_form();
    })

    $(window).on('scroll', function () {
      if (window.pageYOffset > 50) {
        $('body').addClass('mobile-sticky-visible');
      } else {
        $('body').removeClass('mobile-sticky-visible');
      }
    })

  } else { /*not mobile*/
    if ($('.countries_wrap a').length > 4) $('.countries_wrap').mySlidePlugin(3, 25);
    if ($('.carlist li').length > 3) $('.carlist').mySlidePlugin(3, 77);
    $('.innerservices').wrapInner('<div />').children().mySlidePlugin(1,1)

    $(window).on('scroll', function () {
      if ( window.scrollY > 400 ) {
        $(".sticky").addClass("visible");
      }
      else {
        $(".sticky").removeClass("visible");
      }
    })
  }

  /*---------------------------------------------click on submit gaq -----------------------------*/

  $('body').on('click', '.gaq .button', function () {
    $('.gaq').addClass('button_tuched');
    $('.gaq.ng-valid').removeClass('button_tuched');
  })

  /*---------------------------------------------------------------------------------------------*/

  /*    $('.columnWrapper .content .more').click(function(){
        $('.columnWrapper .content').addClass('more');
        })
        $('.columnWrapper .content .less').click(function(){
        $('.columnWrapper .content').removeClass('more');
        })*/

  /*---------------------------------------------------------------------------------------------*/

  $('.wrapper.stage_two .search_button').click(function () {
    $('.stage_two_main .right .wp').addClass('insearch');
    setTimeout(function () {
      $('.stage_two_main .right .wp').removeClass('insearch');
      $('#search > nav > span').click(function () {
        $('.stage_two_main .right .wp').addClass('insearch');
        setTimeout(function () {
          $('.stage_two_main .right .wp').removeClass('insearch');
        }, 1500);
      })
    }, 2000);
  })

  /*----------------------------------------------------------------------------------------------*/
  $('body').on('submit', '.send_email', function() {
    var email = $(this).children('input').val();
    $.post('/email', { email: email });
    $('body').addClass('subscribed')
    return false;
  });

  $('[role=availability]').click(function() {
    $('.search_wrap .btn_search').trigger('click');
  });
  // --- show hide menu --- //
  $('header .icon-menubutton').on('click', function() { $(this).toggleClass('active') });
  $(document).click(function(event) { 
    if (event.target.classList.contains('icon-menubutton')) return;
    if ($(event.target).closest('.mainNav').length>0 || $(event.target).is('.mainNav')) return;
    $('.icon-menubutton').removeClass('active');
  })
  // --- show hide menu --- //
  $('.animNav,body>header').on('click', '.menuList .parent', function () {
    var current_class = this.id;
    $('.menulist_button,.menulist_block').addClass(current_class + ' active');
    $('.menulist_button').click(function () {
      $('.menulist_button,.menulist_block').removeClass('active');
      setTimeout(function () {
        $('.menulist_button,.menulist_block').removeClass(current_class)
      }, 800);
    })
  })

  $('body').append('<div id=static></div>');
  $('body').on('click','[href="/about"],[href*="jobs"],[href="/faq"]', function (e) {
    e.preventDefault();
    $('#static').load(this.getAttribute('href') + ' div.static', function () {
      $.magnificPopup.open({
        mainClass: 'mfp-fade',
        removalDelay: 400,
        overflowY: 'scroll',
        items: [
      {
        type: 'inline',
        src: '#static'
      }
      ]
      })
      if($('body').hasClass('menu-active')){$('.icon').trigger('click');}
    })
  })

  /*------------------------------- light box -------------------------------------------*/

  $("header .icon").click(function (event) {
    event.stopPropagation();
    $('.wrapper').toggleClass("menu-active");

  })
  $('.lb').click(function (event) {
    $('.wrapper').removeClass('menu-active');
  })


  /*--------------------------------------------------------------------------------------*/

  $('.choose span').click(function () {
    if ($(this).hasClass('choose_brand')) {
      $('.result_block').removeClass('category').addClass('brand');
    }
    else if ($(this).hasClass('choose_category')) {
      $('.result_block').removeClass('brand').addClass('category');
    }
  })

  /*--------------------------------------car block slider--------------------------------*/

  function create_image_slide() {
    var imgArr = $('.car_block .img_wrap img');
    $(imgArr[0]).addClass('active');
    $('.car_block .slide').append(imgArr.clone());
  }

  if ($('body').hasClass('car_page')) {
    create_image_slide();
  }
  $('.car_block .slide').on('click', 'img', function () {
    switch_to_image_in_gallery(this);
    clearInterval(gallery_interval);
    $('.car_block .img_wrap iframe').remove();
  });
  $('.mobile .car_block').on('flick', '.img_wrap img', function (e) {
    e.direction < 0 ? next_image_in_gallery() : prev_image_in_gallery();
    clearInterval(gallery_interval)
  });
  function switch_to_image_in_gallery(elm) {
    $('.car_block img').removeClass('active');
    var ind = $('.car_block .slide img').index(elm);
    $('.car_block .img_wrap img:eq(' + ind + ')').add(elm).addClass('active');
        }

        function prev_image_in_gallery() {
          var next = $('.car_block .slide .active').prevAll('img')[0];
          if (!next) next = $('.car_block .slide img:last')[0];
          switch_to_image_in_gallery(next);
        }

        function next_image_in_gallery() {
          var next = $('.car_block .slide .active').nextAll('img')[0];
          if (!next) next = $('.car_block .slide img:first')[0];
          switch_to_image_in_gallery(next);
        }

        var gallery_interval = setInterval(next_image_in_gallery, 5000);
        if (isMobile()) { // move gallery in other block
          $('.car_page .car_block').insertAfter('.car .right ul')
        }

        var video = $('.car_block .img_wrap img[data-video]:last').data('video');
        if (video) {
          $('.car_block .img_wrap').append($('<button>PLAY</button>').click(function (ev) {
            $('.car_block .img_wrap').append('<iframe width="600" height="450" src="https://www.youtube.com/embed/' + video + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
            clearInterval(gallery_interval);
          }));
        }

        /*------------------------------------------------------------------------------------------*/

        // image editorial
        $('img[data-credentials],img[longdesc]').each(function () {
          var cred = $(this).data('credentials') || $(this).attr('longdesc');
          $(this).after($('<cite>' + cred + '</cite>'));
        });
        // image editorial



        var car_page_map = function () {
          var map;

          function initialize() {
            var mapOptions = {
              zoom: 2,
              center: new google.maps.LatLng(place.lat, place.lng)
            };
            var map_elm = document.getElementById('map');
            if (!map_elm) return;
            map = new google.maps.Map(map_elm, mapOptions);
          }

          google.maps.event.addDomListener(window, 'load', initialize);
        };
        // never run if (typeof(place) != 'undefined') car_page_map();
})

/*-------------------------------------------------------------------------*/








/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/script.js
 ** module id = 32
 ** module chunks = 0
 **/